import CustomerRepository from "./repositories/customerRepository";
import AdSpecialRepository from "./repositories/adspecialRepository";
import CampaignRepository from "./repositories/campaignRepository";
import AttachmentRepository from "./repositories/attachmentRepository";
import EnvironmentRepository from "./repositories/environmentRepository";
import FormulaRepository from "./repositories/formulaRepository";
import InteractionRepository from "./repositories/interactionRepository";
import MediumRepository from "./repositories/mediumRepository";
import ModuleRepository from "./repositories/moduleRepository";
import SiteRepository from "./repositories/siteRepository";
import SpaceRepository from "./repositories/spaceRepository";
import TrackingListRepository from "./repositories/trackinglistRepository";
import InsertionOrderRepository from "./repositories/insertionOrderRepository";

const repositories = {
  customers : CustomerRepository,
  adSpecials : AdSpecialRepository,
  campaigns : CampaignRepository,
  attachments : AttachmentRepository,
  environments : EnvironmentRepository,
  formulas : FormulaRepository,
  interactions : InteractionRepository,
  mediums : MediumRepository,
  modules : ModuleRepository,
  sites : SiteRepository,
  spaces : SpaceRepository,
  trackingLists : TrackingListRepository,
  insertionOrders: InsertionOrderRepository
};

export const RepositoryFactory = {
  get: name => repositories[name]
};